import React from 'react';
import logo from '../../images/logo.png';

const Loading = () => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100vh', background: 'white' }}>
        <img src={logo} alt="" style={{ width: '80px', height: '80px', objectFit: 'contain' }} className="animate-pulse" />
    </div>
);

export default Loading;
